export default __webpack_public_path__ + "static/media/flechaAmarilla.f534dc78.svg";